import React from "react";
import { useAtomValue, useSetAtom } from "jotai";
import { VisorFormulario } from "pages/consultar/bandeja-tareas/components/VisorFormulario";
import { loadingPdfAtom } from "pages/consultar/bandeja-tareas/store/Store";
import { eventoAtom } from "pages/legajo/legajoV3/LegajoColaboradorStore";
import { Evento } from "./Evento";

const ModalCompletarFormulario = () => {

    const loadingPdf = useAtomValue(loadingPdfAtom);
    const setEvento = useSetAtom(eventoAtom);

    const onCompletado = (documento) => {
        setEvento({ envioId: documento.envio.id, accion: Evento.ACTUALIZAR_LISTA_DOCUMENTOS });
    };

    return <VisorFormulario loadingPdf={loadingPdf} onCompletado={onCompletado} />;
};

export default ModalCompletarFormulario;
